// extracted by mini-css-extract-plugin
module.exports = {"container":"v_column_container_container__1WpUe","title":"v_column_container_title__3NtoE"};